export default function AnnouncementBar() {
  const items = Array.from({ length: 18 });

  return (
    <div className="announcement" aria-label="Promotion">
      <div className="announcement-track">
        {[...items, ...items].map((_, i) => (
          <span key={i}>
            <i />
            Get 10% Off on First Order
            <i />
          </span>
        ))}
      </div>
    </div>
  );
}